/* Wide PDP (2026-10-11). Loaded only by sections/pt-wide-layout.liquid (product.wide-quarter / product.wide-third).
   Layout is pure CSS (assets/pt-wide-pdp.css); this file only adds behaviour:
   - gallery: "1 / N" counter, "+N" on the last thumb that fits the photo height (opens the existing lightbox),
     "Customer photos" tile under the thumbs when a review has a photo (jumps to Reviews, photos filter on)
   - specs SKU follows the selected variant
   - buy box fitment has no GO / CLEAR: any change that completes the vehicle checks it
   - <ptw-mosaic>   01 tiles (not clickable): clips play once per visit to the screen; a round Replay icon shows on a clip once it has ended;
                    carousel layout: arrows + each clip plays once as it comes into view (phones: the grid is a swipeable row, same rule)
   - FAQ moves inside the description, under "Read full description" (owner 10-12)
   - header (>=1024): the menu row slides away on scroll down and comes back on scroll up (RealTruck); the buy box follows
   - buy box (>=1024): a wheel over it always scrolls it first (no visible bar)
   - <ptw-more>     03 "Read full description"
   - <ptw-videos>   04 video cards open a player dialog (iframe built from a <template> on click)
   - <ptw-vehicle>  05 "Specs for <vehicle>" bar, only while the fitment widget says the garage vehicle fits
   - <ptw-ask>      "Ask a question" opens the buy box support chat
   No external URLs, no eval. */
(function () {
  'use strict';
  var W = window, D = document;
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var WIDE = W.matchMedia ? W.matchMedia('(min-width: 1024px)') : { matches: true };
  var PHONE = W.matchMedia ? W.matchMedia('(max-width: 749.98px)') : { matches: false };
  function define(name, cls) { if (W.customElements && !W.customElements.get(name)) W.customElements.define(name, cls); }
  function headerOffset() {
    var h = parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--header-height'));
    return (isNaN(h) ? 0 : h) + 16;
  }

  /* ---------- 01 Advanced features mosaic ----------
     Clips play ONCE when the mosaic scrolls into view and then rest on their last frame. They play
     again only after the mosaic has left the screen completely and come back. Each clip has its own
     round Replay icon (top right of its tile), shown only once that clip has ended (owner 10-12).
     Tiles are not clickable. Reduced motion: nothing autoplays, so the icons show from the start. */
  class PtwMosaic extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('.ptw-tile'));
      this.setAttribute('data-n', String(this.tiles.length));
      /* arrows: the carousel layout's, and the phone row of the grid (owner 10-14); stills need them too */
      this.carousel();
      this.videos = Array.prototype.slice.call(this.querySelectorAll('video[data-src]'));
      if (!this.videos.length) return;
      this.videos.forEach(function (v) { v.loop = false; v.removeAttribute('loop'); });
      var self = this;
      /* the poster sits behind each clip, so the tile never shows black while a clip loads */
      this.videos.forEach(function (v) {
        var m = v.parentElement, po = v.getAttribute('poster');
        if (m && po) { m.style.backgroundImage = 'url("' + po + '")'; m.style.backgroundSize = 'cover'; m.style.backgroundPosition = v.style.objectPosition || '50% 50%'; }
      });
      /* a tap on a clip that is not playing plays it (owner 10-14: "even if I tap it, it doesn't play") */
      this.tiles.forEach(function (tile) {
        var v = tile.querySelector('video[data-src]');
        if (!v) return;
        tile.addEventListener('click', function (e) {
          if (e.target.closest('.ptw-tile__replay') || !v.paused) return;
          tile._seen = true; self.load(); if (v.ended) self.play(v); else self.resume(v);
        });
      });
      this.querySelectorAll('.ptw-tile__replay').forEach(function (b) {
        var tile = b.closest('.ptw-tile'), v = tile.querySelector('video[data-src]');
        if (!v) return;
        b.hidden = false;
        var ended = function (on) { tile.classList.toggle('is-ended', on); };
        v.addEventListener('ended', function () { ended(true); });
        v.addEventListener('play', function () { ended(false); });
        if (RM.matches) ended(true);
        b.addEventListener('click', function () { self.load(); self.play(v); });
      });
      this.seen = false;
      /* fetch the clips a screen ahead of the mosaic, so the first frame is ready when a clip starts (no black flash) */
      if ('IntersectionObserver' in W) {
        var pre = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { self.load(); pre.disconnect(); } }, { rootMargin: '0px 0px 900px 0px' });
        pre.observe(this);
      }
      this.observe();
      /* phones show the grid as one swipeable row (owner 10-14), so the play rule follows the breakpoint */
      if (this.getAttribute('data-layout') !== 'carousel' && PHONE.addEventListener) PHONE.addEventListener('change', this.observe.bind(this));
      var onMotion = this.motion.bind(this);
      if (RM.addEventListener) RM.addEventListener('change', onMotion);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    /* carousel, and the grid on phones: most clips start off screen, so each plays once as it comes into view and
       again only after it has left the screen completely. Grid on wider screens: the whole mosaic plays once when it
       scrolls into view, and again only after it has left the screen completely. */
    observe() {
      var self = this;
      if (!('IntersectionObserver' in W)) { this.load(); if (!RM.matches) this.playAll(); return; }
      if (this.io) this.io.disconnect();
      this.pauseAll();
      this.seen = false;
      this.tiles.forEach(function (t) { t._seen = false; });
      if (this.getAttribute('data-layout') === 'carousel' || PHONE.matches) {
        /* smooth playback (owner 10-14 "the gifs are bugging out"): a card has to SETTLE in view (60% for 300ms) before
           it starts, so cards that only slide past while swiping no longer restart and freeze on their first frame.
           A clip that leaves mid-play carries on from where it was when it comes back; a clip that ended plays from the
           start again only after it has left the screen completely. */
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var t = en.target, v = t.querySelector('video[data-src]');
            if (!v) return;
            clearTimeout(t._tm);
            if (!en.isIntersecting) { if (!v.paused) v.pause(); if (v.ended) t._seen = false; return; }
            if (en.intersectionRatio < 0.6 || RM.matches) return;
            t._tm = setTimeout(function () {
              self.load();
              if (!t._seen) { t._seen = true; self.play(v); }
              else if (v.paused && !v.ended) self.resume(v);
            }, 300);
          });
        }, { threshold: [0, 0.6] });
        this.tiles.forEach(function (t) { self.io.observe(t); });
      } else {
        this.io = new IntersectionObserver(function (entries) {
          var en = entries[entries.length - 1];
          if (!en.isIntersecting) { self.seen = false; self.pauseAll(); return; }
          if (!self.seen && en.intersectionRatio >= 0.3) {
            self.seen = true;
            self.load();
            if (!RM.matches) self.playAll();
          }
        }, { threshold: [0, 0.3] });
        this.io.observe(this);
      }
    }
    /* carousel arrows (on the clips): one card per click; hidden at either end */
    carousel() {
      var self = this, sec = this.closest('.ptw-sec');
      var btns = sec ? Array.prototype.slice.call(sec.querySelectorAll('[data-ptw-car]')) : [];
      if (!btns.length) return;
      var step = function () {
        var t = self.tiles[0];
        return t ? t.getBoundingClientRect().width + parseFloat(getComputedStyle(self).columnGap || 0) : self.clientWidth;
      };
      var state = function () {
        var max = self.scrollWidth - self.clientWidth - 2;
        btns.forEach(function (b) { b.disabled = b.getAttribute('data-ptw-car') === '-1' ? self.scrollLeft <= 2 : self.scrollLeft >= max; });
      };
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          self.scrollBy({ left: step() * parseInt(b.getAttribute('data-ptw-car'), 10), behavior: RM.matches ? 'auto' : 'smooth' });
        });
      });
      this.addEventListener('scroll', function () { W.requestAnimationFrame(state); }, { passive: true });
      W.addEventListener('resize', state);
      state();
    }
    load() {
      this.videos.forEach(function (v) {
        if (!v.getAttribute('src')) {
          v.preload = RM.matches ? 'metadata' : 'auto';
          v.src = v.getAttribute('data-src');
        }
      });
    }
    /* Start from the first frame straight away. iPhone Safari downloads nothing until play() is called, so play() is
       never held back waiting for data (owner 10-14: a clip in view after a refresh never started). While the first frame
       is still on its way the video is kept transparent over its own poster (set as the tile background), so Safari's
       black gap never shows. */
    play(v) {
      if (v.currentTime > 0) { try { v.currentTime = 0; } catch (e) { /* not seekable yet: it starts at 0 anyway */ } }
      this.start(v);
    }
    resume(v) { this.start(v); }
    start(v) {
      if (v.readyState < 2) {
        v.style.opacity = '0';
        var show = function () { v.style.opacity = ''; };
        v.addEventListener('playing', show, { once: true });
        setTimeout(show, 4000);
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.style.opacity = ''; });
    }
    playAll() { var self = this; this.videos.forEach(function (v) { self.play(v); }); }
    pauseAll() { this.videos.forEach(function (v) { if (!v.paused) v.pause(); }); }
    motion() { if (RM.matches) this.pauseAll(); }
  }
  define('ptw-mosaic', PtwMosaic);

  /* ---------- 03 Description clamp ---------- */
  class PtwMore extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.btn = this.querySelector('.ptw-more__toggle');
      this.body = this.querySelector('.ptw-more__body');
      if (!this.btn || !this.body) return;
      this.btn.addEventListener('click', this.toggle.bind(this));
      var check = function () {
        if (!self.classList.contains('is-clamped')) return;
        /* Owner 10-13: when the description has a fitment table, cut just below its first rows (max 2)
           instead of at a fixed height that can land on the table's black header bar. */
        self.body.style.maxHeight = '';
        var rows = [].filter.call(self.body.querySelectorAll('.pt-fitw tbody tr'), function (r) { return r.offsetHeight > 0; }).slice(0, 2);
        if (rows.length) {
          var cut = rows[rows.length - 1].getBoundingClientRect().bottom - self.body.getBoundingClientRect().top + 64;
          if (cut > 0 && cut < self.body.scrollHeight - 40) self.body.style.maxHeight = Math.ceil(cut) + 'px';
        }
        self.classList.remove('is-short');
        var over = self.body.scrollHeight > self.body.clientHeight + 2;
        self.classList.toggle('is-short', !over);
        self.btn.hidden = !over;
      };
      this._check = check;
      W.requestAnimationFrame(check);
      W.addEventListener('load', check, { once: true });
      if ('ResizeObserver' in W) new ResizeObserver(check).observe(this.body);
    }
    toggle() {
      var open = this.classList.contains('is-clamped');
      this.classList.toggle('is-clamped', !open);
      if (open) this.body.style.maxHeight = '';
      else if (this._check) this._check();
      this.btn.setAttribute('aria-expanded', String(open));
      this.btn.textContent = open ? this.btn.getAttribute('data-less') : this.btn.getAttribute('data-more');
      if (!open) {
        /* Owner 10-18: on "Read less" bring the description section's top back into view. */
        var top = (this.closest('.ptw-sec') || this).getBoundingClientRect().top;
        if (top < headerOffset()) W.scrollTo({ top: W.scrollY + top - headerOffset() - 60, behavior: 'auto' });
      }
    }
  }
  define('ptw-more', PtwMore);

  /* ---------- 04 Video cards ---------- */
  class PtwVideos extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.dlg = this.querySelector('.ptw-vdlg');
      this.frame = this.querySelector('.ptw-vdlg__frame');
      if (!this.dlg || !this.frame) return;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('.ptw-vid');
        if (b) { self.open(b); return; }
        if (e.target.closest('.ptw-vdlg__x') || e.target === self.dlg) self.close();
      });
      this.dlg.addEventListener('close', function () {
        self.frame.innerHTML = '';
        if (self.opener && self.opener.focus) self.opener.focus();
      });
    }
    open(b) {
      var tpl = b.parentElement && b.parentElement.querySelector('template');
      if (!tpl) return;
      this.opener = b;
      this.frame.innerHTML = '';
      this.frame.appendChild(tpl.content.cloneNode(true));
      if (typeof this.dlg.showModal === 'function') this.dlg.showModal(); else this.dlg.setAttribute('open', '');
    }
    close() {
      if (typeof this.dlg.close === 'function') this.dlg.close(); else { this.dlg.removeAttribute('open'); this.frame.innerHTML = ''; }
    }
  }
  define('ptw-videos', PtwVideos);

  /* ---------- 05 "Specs for <vehicle>" ---------- */
  class PtwVehicle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.lab = this.querySelector('[data-ptw-veh-label]');
      var chg = this.querySelector('.ptw-veh__chg');
      if (chg) chg.addEventListener('click', function (e) {
        var api = self.api();
        if (api && api.open) api.open('change', e.currentTarget, api.store && api.store.active ? api.store.active() : undefined);
      });
      var update = this.update.bind(this);
      D.addEventListener('fitment:change', update);
      var watch = function () {
        var ver = D.querySelector('pt-fitment-verify');
        if (ver) new MutationObserver(update).observe(ver, { attributes: true, attributeFilter: ['data-state'] });
        update();
      };
      if (D.readyState === 'complete') watch(); else W.addEventListener('load', watch, { once: true });
    }
    api() { return W.theme && W.theme.fitment && W.theme.fitment.api; }
    update() {
      var api = this.api(), ver = D.querySelector('pt-fitment-verify');
      var v = api && api.store && api.store.active ? api.store.active() : null;
      var fits = !!(ver && ver.getAttribute('data-state') === 'fits');
      if (v && fits && api.label && this.lab) {
        this.lab.textContent = api.label(v);
        this.hidden = false;
      } else {
        this.hidden = true;
      }
    }
  }
  define('ptw-vehicle', PtwVehicle);

  /* ---------- Ask bar ---------- */
  class PtwAsk extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var a = this.querySelector('.ptw-ask__link');
      if (a) a.addEventListener('click', function (e) {
        var sup = D.querySelector('pt-support');
        if (sup && typeof sup.open === 'function') { e.preventDefault(); sup.open(); }
      });
    }
  }
  define('ptw-ask', PtwAsk);

  /* ---------- Gallery: counter pill and "+N" thumb ---------- */
  function gallery() {
    var gal = D.querySelector('.main-product__gallery');
    if (!gal || gal.getAttribute('data-ptw')) return;
    gal.setAttribute('data-ptw', '1');
    var list = gal.querySelector('.main-product__media-list');
    if (!list) return;
    var media = Array.prototype.slice.call(list.querySelectorAll('.main-product__media'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.main-product__thumb'));
    var rail = gal.querySelector('.main-product__thumbs');

    var activeIndex = function () {
      for (var k = 0; k < media.length; k++) if (media[k].classList.contains('is-active')) return k;
      return 0;
    };
    var pill = null;
    if (media.length > 1) {
      var cap = D.createElement('div');
      cap.className = 'ptw-galcap';
      pill = D.createElement('span');
      pill.className = 'ptw-count';
      pill.setAttribute('aria-hidden', 'true');
      cap.appendChild(pill);
      list.insertAdjacentElement('afterend', cap);
    }
    var zoom = D.createElement('button');
    zoom.type = 'button';
    zoom.className = 'ptw-zoom';
    zoom.setAttribute('aria-label', 'Zoom image');
    zoom.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.3-4.3M11 8.5v5M8.5 11h5"/></svg>';
    zoom.addEventListener('click', function () {
      var img = list.querySelector('.main-product__media.is-active img');
      if (img) img.click();
    });
    list.appendChild(zoom);
    var count = function () {
      var i = activeIndex();
      if (pill) pill.textContent = (i + 1) + ' / ' + media.length;
      /* the active photo may sit behind the "+N" thumb: light that one up instead */
      var more = gal.querySelector('.main-product__thumb[data-ptw-more]');
      thumbs.forEach(function (t) { t.classList.remove('ptw-thumb--on'); });
      if (more && thumbs.indexOf(more) <= i) more.classList.add('ptw-thumb--on');
    };
    count();
    new MutationObserver(count).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });

    if (thumbs.length < 2 || !rail) return;
    var pics = custPics(rail);
    var fit = function () {
      thumbs.forEach(function (t) { t.classList.remove('ptw-thumb--hide'); t.removeAttribute('data-ptw-more'); });
      if (!WIDE.matches) return;
      var h = list.getBoundingClientRect().height;
      if (!h) return;
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.rowGap) || 10;
      var th = thumbs[0].getBoundingClientRect().height || 60;
      /* the "Customer photos" tile keeps the last slot of the rail */
      var n = Math.floor((h + gap) / (th + gap)) - (pics ? 1 : 0);
      if (n < 1 || n >= thumbs.length) return;
      thumbs.forEach(function (t, i) { if (i >= n) t.classList.add('ptw-thumb--hide'); });
      var last = thumbs[n - 1];
      last.setAttribute('data-ptw-more', '+' + (thumbs.length - n + 1));
      last.setAttribute('aria-label', 'Show all ' + thumbs.length + ' images');
      count();
    };
    fit();
    if ('ResizeObserver' in W) new ResizeObserver(fit).observe(list);
    else W.addEventListener('resize', fit);
    if (WIDE.addEventListener) WIDE.addEventListener('change', fit);

    /* "+N": theme.js (document listener) shows that slide, then its image opens the existing lightbox */
    gal.addEventListener('click', function (e) {
      /* real clicks only: the lightbox's close() and the arrows click thumbs from script */
      var t = e.isTrusted && e.target.closest('.main-product__thumb[data-ptw-more]');
      if (!t) return;
      W.setTimeout(function () {
        var img = list.querySelector('.main-product__media.is-active img');
        if (img) img.click();
      }, 0);
    });
  }

  /* ---------- "Customer photos" tile at the foot of the thumb rail (Round 4 board) ----------
     Only when at least one review on this page has a photo. Jumps to Reviews with "With photos" on. */
  function custPics(rail) {
    var root = D.querySelector('#main-content .ptr');
    if (!root || !root.querySelector('.ptr__card[data-ptr-haspic="1"]')) return null;
    var b = D.createElement('button');
    b.type = 'button';
    b.className = 'ptw-custpics';
    b.setAttribute('aria-label', 'See customer photos in the reviews');
    b.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3.5L9 5.5h6L16.5 8H20v11H4z"/><circle cx="12" cy="13.5" r="3.5"/></svg><span>Customer<br>photos</span>';
    b.addEventListener('click', function () {
      var f = root.querySelector('[data-ptr-filter="photos"]');
      if (f && !f.classList.contains('is-on')) f.click();
      var top = root.getBoundingClientRect().top + W.scrollY - headerOffset();
      W.scrollTo({ top: Math.max(0, top), behavior: RM.matches ? 'auto' : 'smooth' });
    });
    rail.appendChild(b);
    return b;
  }

  /* ---------- specs Part Number / UPC follow the variant (owner V1 2026-10-18) ---------- */
  /* ---------- rework S1: highlight the selected version's row in the versions table ---------- */
  function verRow() {
    var rows = D.querySelectorAll('.pt-varspec tr[data-sku]');
    var wrap = D.querySelector('[data-product-form-wrapper]');
    if (!rows.length || !wrap) return;
    var variants = [];
    try { variants = JSON.parse((wrap.querySelector('[data-variants-json]') || {}).textContent || '[]'); } catch (e) { variants = []; }
    var input = wrap.querySelector('input[data-variant-id]');
    var apply = function () {
      if (!input) return;
      var id = parseInt(input.value, 10), sku = null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) { sku = String(variants[i].sku || ''); break; }
      Array.prototype.forEach.call(rows, function (r) {
        var on = sku !== null && r.getAttribute('data-sku') === sku;
        r.classList.toggle('ptw-vrow--on', on);
        if (on) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current');
      });
    };
    wrap.addEventListener('change', function () { W.setTimeout(apply, 0); });
    apply();
  }

  function variantSku() {
    var wrap = D.querySelector('[data-product-form-wrapper]');
    if (!wrap || !D.querySelector('[data-ptw-sku], [data-ptw-upc]')) return;
    var variants = [];
    try { variants = JSON.parse((wrap.querySelector('[data-variants-json]') || {}).textContent || '[]'); } catch (e) { variants = []; }
    if (variants.length < 2) return;
    var input = wrap.querySelector('input[data-variant-id]');
    var apply = function () {
      if (!input) return;
      var id = parseInt(input.value, 10), v = null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) { v = variants[i]; break; }
      if (!v) return;
      var put = function (sel, val) {
        Array.prototype.forEach.call(D.querySelectorAll(sel), function (o) {
          o.textContent = val || '';
          var line = o.closest('tr');
          if (line) line.hidden = !val; /* no value -> no row, never a blank one */
        });
      };
      var bpn = null; /* brand part number from the versions table row (owner: never a distributor code) */
      Array.prototype.forEach.call(D.querySelectorAll('.pt-varspec tr[data-sku]'), function (r) { if (bpn === null && r.getAttribute('data-sku') === String(v.sku || '')) { var c = r.querySelector('td'); bpn = c ? c.textContent.trim() : null; } });
      put('[data-ptw-sku]', bpn || v.sku);
      put('[data-ptw-upc]', v.barcode);
    };
    wrap.addEventListener('change', function () { W.setTimeout(apply, 0); });
    apply();
  }

  /* ---------- 05 delivery line mirrors the buy box estimate ---------- */
  function eta() {
    var outs = D.querySelectorAll('[data-ptw-eta]');
    if (!outs.length) return;
    var src = D.querySelector('.pib-p__block--eta pt-eta') || D.querySelector('.pib-p__block--eta .pib-p__txt b');
    if (!src) return;
    var copy = function () {
      var t = (src.textContent || '').replace(/\s+/g, ' ').trim();
      Array.prototype.forEach.call(outs, function (o) {
        o.textContent = t;
        var p = o.closest('.ptw-eta');
        if (p) p.hidden = !t;
      });
    };
    copy();
    new MutationObserver(copy).observe(src, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- 04: drop a lead-in line ("Watch the walkthrough:") left dangling by a hidden video ---------- */
  function dangling() {
    Array.prototype.forEach.call(D.querySelectorAll('.ptw-rte iframe[data-ptw-src]'), function (f) {
      var box = f;
      while (box.parentElement && !box.parentElement.classList.contains('ptw-rte')) box = box.parentElement;
      var prev = box.previousElementSibling;
      if (prev && prev.tagName === 'P' && /:\s*$/.test(prev.textContent || '')) prev.hidden = true;
    });
  }

  /* ---------- buy box fitment: no GO / CLEAR (owner 10-12, as RealTruck) ----------
     fitment.js already checks the vehicle when the LAST select is picked. Changing an earlier select of a
     filled form waited for GO, so here that change checks the vehicle too. Runs after the widget's own
     cascade (next tick), and never on the last level, which fitment.js submits itself. */
  function autoFit() {
    var vs = D.querySelector('.main-product__info pt-fitment-verify pt-vehicle-select');
    if (!vs) return;
    vs.addEventListener('change', function (e) {
      var lv = e.target && e.target.getAttribute && e.target.getAttribute('data-fitment-level');
      if (!lv) return;
      W.setTimeout(function () {
        if (typeof vs.complete !== 'function' || !vs.complete()) return;
        var last = vs.hasBeds() ? 'bed' : vs.hasSubs() ? 'submodel' : 'model';
        if (lv !== last) vs.submit();
      }, 0);
    });
  }

  /* ---------- header (>=1024): RealTruck's collapsing menu row (owner 10-12) ----------
     Scrolling down hides the menu row and Select your vehicle (they slide up behind the logo row);
     scrolling up, or being near the top, brings them back. The header keeps its height in the page
     (no layout shift); the hidden strip lets clicks through. --header-height follows, so the sticky
     buy box moves up with it. Focus inside the header (search, garage) always shows the full header. */
  function header() {
    var hdr = D.querySelector('.site-header'), nav = hdr && hdr.querySelector('.site-header__nav');
    if (!hdr || !nav) return;
    var root = D.documentElement, min = false, lastY = W.scrollY, acc = 0, ticking = false, t = 0;
    function apply() {
      root.style.setProperty('--ptw-hdr-top', nav.offsetTop + 'px');
      /* always the full height, also while collapsed: the sticky buy box keeps its place instead of sliding
         56px each time the menu row hides or shows (owner 10-12 r10; RealTruck pins its box the same way) */
      root.style.setProperty('--header-height', hdr.offsetHeight + 'px');
    }
    function set(on) {
      on = !!on && WIDE.matches;
      if (on === min) return;
      min = on;
      D.body.classList.toggle('ptw-hdr-min', on);
      apply();
    }
    function onScroll() {
      ticking = false;
      var y = W.scrollY, d = y - lastY;
      lastY = y;
      if (!WIDE.matches || y < 200) { acc = 0; set(false); return; }
      if (hdr.contains(D.activeElement)) { acc = 0; set(false); return; }
      acc = (d > 0) === (acc > 0) ? acc + d : d;
      if (acc > 24) set(true); else if (acc < -24) set(false);
    }
    W.addEventListener('scroll', function () { if (!ticking) { ticking = true; W.requestAnimationFrame(onScroll); } }, { passive: true });
    hdr.addEventListener('focusin', function () { set(false); });
    /* the theme resets --header-height on resize (150ms debounce); set ours after it */
    W.addEventListener('resize', function () { W.clearTimeout(t); t = W.setTimeout(function () { if (!WIDE.matches) set(false); apply(); }, 220); });
    apply();
  }

  /* ---------- buy box wheel (>=1024) ----------
     The box scrolls on its own (sticky, own scroll, no visible bar). Browsers keep a wheel gesture on
     the scroller it started on, so a scroll begun over the left column kept moving the page after the
     mouse reached the box (owner 10-12). Here a wheel over the box always moves the box while it can
     still go that way; at its top or bottom the page scrolls as normal. Eased so a wheel notch glides. */
  function boxWheel() {
    var box = D.querySelector('.main-product__info');
    if (!box) return;
    var target = null, raf = 0;
    function step() {
      var cur = box.scrollTop, d = target - cur, s;
      if (Math.abs(d) < 1) { box.scrollTop = target; target = null; raf = 0; return; }
      s = d * 0.28;
      if (Math.abs(s) < 1) s = d > 0 ? 1 : -1;
      box.scrollTop = cur + s;
      if (box.scrollTop === cur) { target = null; raf = 0; return; } /* could not move (end reached): stop */
      raf = W.requestAnimationFrame(step);
    }
    box.addEventListener('wheel', function (e) {
      if (!WIDE.matches || e.ctrlKey || e.defaultPrevented) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; /* sideways: the add-on rail scrolls */
      var dy = e.deltaY * (e.deltaMode === 1 ? 32 : e.deltaMode === 2 ? box.clientHeight : 1);
      var max = box.scrollHeight - box.clientHeight;
      if (!dy || max <= 0) return;
      var from = target === null ? box.scrollTop : target;
      if ((dy > 0 && from >= max - 1) || (dy < 0 && from <= 0)) return; /* at an end: let the page scroll */
      e.preventDefault();
      target = Math.max(0, Math.min(max, from + dy));
      if (RM.matches) { box.scrollTop = target; target = null; return; }
      if (!raf) raf = W.requestAnimationFrame(step);
    }, { passive: false });
    box.addEventListener('scroll', function () { if (!raf) target = null; }, { passive: true });
  }

  /* ---------- FAQ inside the description (owner 10-12) ----------
     The FAQ section moves to the end of the description body, so it shows under "Read full description"
     (the clamp hides it until then). Without JS it stays a section of its own under the description. */
  function faqIntoDesc() {
    var faq = D.querySelector('#main-content .product-faq'), body = D.querySelector('#main-content .ptw-desc .ptw-more__body');
    if (!faq || !body || body.contains(faq)) return;
    var sec = faq.closest('.shopify-section');
    var box = D.createElement('div');
    box.className = 'ptw-more__faq';
    box.appendChild(faq);
    body.appendChild(box);
    if (sec && !sec.children.length) sec.hidden = true;
  }

  function run() {
    faqIntoDesc();
    header();
    boxWheel();
    autoFit();
    gallery();
    variantSku();
    verRow();
    eta();
    dangling();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', run); else run();
})();

/* Owner 10-13: install steps start collapsed after step 1; "Show all N steps" opens the rest (the videos sit outside). */
(function () {
  if (!window.customElements || customElements.get('ptw-steps')) return;
  customElements.define('ptw-steps', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      var ol = this.querySelector('ol'); if (!ol || ol.children.length < 2) return;
      var n = ol.children.length, more = 'Read more', less = 'Read less', self = this;
      if (!ol.id) ol.id = 'ptw-steps-' + Math.random().toString(36).slice(2, 8);
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ptw-steps__btn'; b.textContent = more;
      b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', ol.id);
      b.addEventListener('click', function () {
        var open = self.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.textContent = open ? less : more;
        /* Owner 10-18: on "Read less" scroll the installation section's top back into view if it is above the viewport. */
        if (!open) {
          var sec = self.closest('.ptw-sec') || self, top = sec.getBoundingClientRect().top;
          var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
          var off = (isNaN(h) ? 0 : h) + 16;
          if (top < off) window.scrollTo({ top: window.scrollY + top - off - 60, behavior: 'auto' });
        }
      });
      ol.insertAdjacentElement('afterend', b);
      this.classList.add('is-clamped');
    }
  });
})();

/* Owner 10-13: More media arrows scroll the row by most of its width. */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-ptw-media-dir]'); if (!b) return;
  var list = b.closest('.ptw-media') && b.closest('.ptw-media').querySelector('.ptw-media__list'); if (!list) return;
  list.scrollBy({ left: list.clientWidth * 0.8 * Number(b.getAttribute('data-ptw-media-dir')), behavior: 'smooth' });
});

/* 2026-10-13 pilot fix: on phones the store-wide inline script (layout, "lazify") parks every i.ytimg.com src on
   data-pt-src until pt-mobile.js opens the tab panel holding it. The wide page has no tab panels, so the More media
   thumbnails and the install video cards stayed blank. Give those images their src back (they keep loading="lazy",
   so the browser still loads them only near the viewport). Scope: .ptw-* blocks only. */
(function () {
  var SEL = '.ptw-media img[data-pt-src], ptw-videos img[data-pt-src], .ptw-videos img[data-pt-src], .ptw-vid img[data-pt-src]';
  function restore(root) {
    var l = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < l.length; i++) { var im = l[i]; if (!im.getAttribute('src')) { im.setAttribute('loading', 'lazy'); im.setAttribute('src', im.getAttribute('data-pt-src')); } }
  }
  function run() { restore(document); setTimeout(function () { restore(document); }, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { restore(document); });
})();

/* ==== Mobile design 1 (owner 2026-10-14, round-4 preview "plain") ==== phones only (<750px), wide-grid pages only.
   Regroups the existing sections into titled sections with dropdowns; no content is added or removed, only moved:
     Features (open) · About this product [Description, Fitment, Videos] · Install & Specs [Install guide,
     Specifications, What's included] · Warranty, Shipping & Returns [4 dropdowns] · FAQ.
   The clip row is the live theme's own phone row. Desktop is untouched. */
(function () {
  var MQ = window.matchMedia('(max-width: 749.98px)');
  if (!MQ.matches || !document.body || !/template-suffix-wide-/.test(document.body.className)) return;
  var ONLY = []; // work copy: every wide page. To limit a live trial, list product handles here.
  var hm = /\/products\/([^\/?#]+)/.exec(location.pathname);
  if (ONLY.length && (!hm || ONLY.indexOf(decodeURIComponent(hm[1])) < 0)) return;
  var D = document;
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function cut(s, n) { return s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '…' : s; }
  function dd(title, summary, nodes, open) {
    var d = D.createElement('details'); d.className = 'ptwm-dd'; if (open) d.open = true;
    var s = D.createElement('summary');
    s.innerHTML = '<span class="ptwm-dd__t"></span>'; // titles only, no preview line (owner 10-14)
    s.firstChild.textContent = title;
    var b = D.createElement('div'); b.className = 'ptwm-dd__b';
    nodes.forEach(function (n) { if (n) b.appendChild(n); });
    d.appendChild(s); d.appendChild(b); return d;
  }
  function section(title, items, before) {
    var sec = D.createElement('section'); sec.className = 'ptw-sec ptwm-sec';
    sec.innerHTML = '<div class="ptw-head"><h2 class="ptw-head__h"></h2></div><div class="ptwm-list"></div>';
    sec.querySelector('h2').textContent = title;
    var list = sec.lastChild; items.forEach(function (i) { if (i) list.appendChild(i); });
    before.parentNode.insertBefore(sec, before); return sec;
  }
  function run() {
    var desc = D.querySelector('.ptw-desc'), more = desc && desc.querySelector('ptw-more');
    var pair = D.querySelector('.ptw-pair'), inst = D.querySelector('.ptw-inst'), spec = D.querySelector('.ptw-specsec');
    var media = D.querySelector('.ptw-media'), ws = D.querySelector('.ptw-ws');
    if (!desc || !more) return;
    D.body.classList.add('ptwm');

    /* ---- About this product: Description · Fitment · Videos ---- */
    var body = more.querySelector('.ptw-more__body'), ov = body.querySelector('.ptw-more__ov'), extra = body.querySelector('.ptw-more__extra'), faq = body.querySelector('.ptw-more__faq');
    var aboutNodes = [];
    if (extra) { // the brand "About …" block + dealer note read as description, not fitment
      var hs = extra.querySelectorAll('h3, h2'), aboutH = null;
      for (var i = 0; i < hs.length; i++) if (/^about\b/i.test(txt(hs[i]))) { aboutH = hs[i]; break; }
      if (aboutH) { var n = aboutH; while (n) { var nx = n.nextSibling; aboutNodes.push(n); n = nx; } }
      var fh = extra.querySelector('h3, h2'); if (fh && /fitment/i.test(txt(fh))) fh.remove();
    }
    var rows = D.querySelectorAll('.ptw-desc .pt-fitw tbody tr'), r0 = rows[0], fitSum = '';
    if (r0) { var c = r0.querySelectorAll('td'); fitSum = [txt(c[0]) + ' ' + txt(c[1]), txt(c[2])].join(' · ') + (rows.length > 1 ? ' + ' + (rows.length - 1) + ' more' : ''); }
    var descDD = dd('Description', cut(txt(ov), 64), [ov].concat(aboutNodes));
    var fitDD = extra ? dd('Fitment', fitSum || 'Check your truck', [extra]) : null;
    var vidDD = null;
    if (media) { var mh = media.querySelector('.ptw-media__head'); var n2 = media.querySelectorAll('.ptw-media__item').length; if (mh) mh.style.display = 'none'; vidDD = dd('Videos', n2 + ' video' + (n2 === 1 ? '' : 's'), [media.querySelector('ptw-videos') || media]); media.remove(); }
    var aboutSec = section('About this product', [descDD, fitDD, vidDD], desc);
    var tg = more.querySelector('.ptw-more__toggle'); if (tg) tg.remove();
    desc.style.display = 'none';

    /* ---- Install & Specs: Install guide · Specifications · What's included ---- */
    var instSec = null;
    if (inst || spec) {
      var ib = inst && inst.querySelector('.ptw-body'), sb = spec && spec.querySelector('.ptw-body');
      var tiles = ib ? [].map.call(ib.querySelectorAll('.ptw-tilestat__v'), txt).filter(Boolean) : [];
      var lbl = ib && ib.querySelector('.ptw-lbl'), ticks = ib && ib.querySelector('.ptw-ticks');
      var guideNodes = ib ? [].slice.call(ib.children).filter(function (x) { return x !== lbl && x !== ticks; }) : [];
      var specRows = sb ? sb.querySelectorAll('tr') : [], specSum = [];
      [].forEach.call(specRows, function (tr) { var k = txt(tr.querySelector('th')), v = txt(tr.querySelector('td')); if (/^(part number|load capacity|warranty)$/i.test(k)) specSum.push(v); });
      var items = [
        guideNodes.length ? dd('Install guide', tiles.slice(0, 3).join(' · '), guideNodes) : null,
        sb ? dd('Specifications', specSum.join(' · ') || specRows.length + ' specs', [].slice.call(sb.children)) : null,
        ticks ? dd("What's included", ticks.children.length + ' item' + (ticks.children.length === 1 ? '' : 's'), [ticks]) : null
      ];
      instSec = section('Install & Specs', items, pair || inst || spec);
      if (lbl) lbl.remove();
      if (pair) pair.style.display = 'none'; else { if (inst) inst.style.display = 'none'; if (spec) spec.style.display = 'none'; }
    }

    /* ---- Warranty, Shipping & Returns: one dropdown per tile ---- */
    if (ws) {
      var SUM = [[/warranty/i, null], [/shipping/i, 'Lower 48 · most orders 1-5 business days'], [/inspect/i, 'Check the box as soon as it arrives'], [/return/i, 'Unused, in the original packaging']];
      var list = D.createElement('div'); list.className = 'ptwm-list';
      [].forEach.call(ws.querySelectorAll('li.ptw-wst'), function (li) {
        var h = li.querySelector('.ptw-wst__h'), t = txt(h), sum = '';
        for (var k = 0; k < SUM.length; k++) if (SUM[k][0].test(t)) { sum = SUM[k][1] || cut(txt(li.querySelector('.ptw-wst__t')).split('. ')[0], 48); break; }
        var nodes = [].slice.call(li.children).filter(function (x) { return x !== h && x.tagName !== 'svg' && x.tagName !== 'SVG'; });
        list.appendChild(dd(t, sum, nodes));
      });
      var wb = ws.querySelector('.ptw-body'); wb.innerHTML = ''; wb.appendChild(list);
    }

    /* ---- FAQ: its own titled section after warranty, rows styled like the warranty dropdowns (Ahmad 10-14) ---- */
    if (faq) {
      var fitems = [].map.call(faq.querySelectorAll('details'), function (q) {
        var qs = q.querySelector('summary'), qt = txt(qs.querySelector('span') || qs), body = q.querySelector('.accordion__content') || q;
        var row = dd(qt, '', [].slice.call(body.childNodes)); row.classList.add('ptwm-dd--q'); return row;
      });
      if (fitems.length) {
        var fsec = section('FAQ', fitems, (ws || instSec || aboutSec).nextSibling || D.body.lastChild);
        fsec.classList.add('ptwm-faq'); (ws || instSec || aboutSec).insertAdjacentElement('afterend', fsec);
        var fwrap = faq.closest('.product-faq') || faq; fwrap.remove();
      }
    }

    /* ---- "Questions about fit or install?" sits under the FAQ instead of hugging the footer (owner 10-14) ---- */
    var ask = D.querySelector('.ptw-sec.ptw-ask'), lastSec = D.querySelector('.ptwm-faq') || ws || instSec || aboutSec;
    if (ask && lastSec) { ask.classList.add('ptwm-ask'); lastSec.insertAdjacentElement('afterend', ask); }

    /* clip row: the live theme's own phone row (arrows, titles above the clips) is kept as is */
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', run); else run();
})();

/* Owner 10-20: "if someone resizes the page it messes up the format". The phone layout (dropdown sections above,
   pt-mobile.js) is built once, at load, for the width the page opened at; dragging the window or rotating a phone
   across 750px left the other layout's pieces in place (phone dropdowns on a desktop page, or a desktop page
   without them on a phone). When the width settles on the other side of 750px, reload the page at the same spot. */
(function () {
  var W = window, D = document;
  if (!W.matchMedia || !D.body || !/template-suffix-wide-/.test(D.body.className)) return;
  var MQ = W.matchMedia('(max-width: 749.98px)'), built = MQ.matches, t = 0, KEY = 'ptw-resize-y';
  try {
    var y = W.sessionStorage.getItem(KEY);
    if (y !== null) {
      W.sessionStorage.removeItem(KEY);
      var go = function () { W.scrollTo(0, Math.round(parseFloat(y) * D.documentElement.scrollHeight)); };
      if (D.readyState === 'complete') go(); else W.addEventListener('load', go, { once: true });
    }
  } catch (e) {}
  function check() {
    W.clearTimeout(t);
    t = W.setTimeout(function () {
      if (MQ.matches === built) return;
      try { W.sessionStorage.setItem(KEY, String(W.scrollY / Math.max(1, D.documentElement.scrollHeight))); } catch (e) {}
      W.location.reload();
    }, 400);
  }
  if (MQ.addEventListener) MQ.addEventListener('change', check); else if (MQ.addListener) MQ.addListener(check);
})();

/* warranty-clamp 2026-10-22 (Option C): desktop (>=1024px) "Read more" for Warranty/Shipping/Returns tiles whose text is
   clipped by the CSS clamp in pt-wide-pdp.css (only the Warranty tile can be). Marks .is-clamped (button shown) or
   .is-fit (nothing hidden: no fade, no button) on load, font load and resize. The button expands THAT tile in place
   (.is-open, "Show less"). Guarded + idempotent; the text itself is never moved or removed. */
(function () {
  var W = window, D = document;
  if (W.__ptwWstClamp || !D.querySelector || !W.matchMedia) return; W.__ptwWstClamp = 1;
  var WIDE = W.matchMedia('(min-width: 1024px)'), n = 0, raf = 0;
  function tiles() { return [].slice.call(D.querySelectorAll('.ptw-ws__tiles > .ptw-wst')); }
  function btnFor(li, body) {
    var b = li.querySelector(':scope > .ptw-wst__more');
    if (b) return b;
    if (!body.id) body.id = 'ptw-wst-t-' + (++n);
    b = D.createElement('button'); b.type = 'button'; b.className = 'ptw-wst__more';
    b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', body.id); b.textContent = 'Read more';
    b.addEventListener('click', function () {
      var open = !li.classList.contains('is-open');
      li.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.textContent = open ? 'Show less' : 'Read more';
      if (!open) { var r = li.getBoundingClientRect(); if (r.top < 0) W.scrollBy(0, r.top - 96); measure(); }
    });
    body.insertAdjacentElement('afterend', b); return b;
  }
  function measure() {
    raf = 0;
    tiles().forEach(function (li) {
      var body = li.querySelector(':scope > .ptw-wst__t'); if (!body || li.classList.contains('is-open')) return;
      var over = WIDE.matches && body.scrollHeight > body.clientHeight + 2;
      if (over) btnFor(li, body);
      li.classList.toggle('is-clamped', over); li.classList.toggle('is-fit', WIDE.matches && !over);
    });
  }
  function later() { if (!raf) raf = (W.requestAnimationFrame || W.setTimeout)(measure); }
  // 10-23: emails / URLs wrap only after "@" or "." (a <wbr> is inserted there; the text itself is unchanged)
  var LONG = /[^\s@<>]+@[^\s@<>]+\.[^\s<>]*[^\s<>.,;:!?)]|(?:https?:\/\/|www\.)[^\s<>]*[^\s<>.,;:!?)]/g;
  function wbr(root) {
    var wk = D.createTreeWalker(root, 4), list = [], t;
    while ((t = wk.nextNode())) { LONG.lastIndex = 0; if (LONG.test(t.nodeValue)) list.push(t); }
    list.forEach(function (node) {
      var s = node.nodeValue, f = D.createDocumentFragment(), last = 0, m; LONG.lastIndex = 0;
      while ((m = LONG.exec(s))) {
        if (m.index > last) f.appendChild(D.createTextNode(s.slice(last, m.index)));
        m[0].replace(/([@.\/])/g, '$1\n').split('\n').filter(Boolean).forEach(function (part, i) { if (i) f.appendChild(D.createElement('wbr')); f.appendChild(D.createTextNode(part)); });
        last = m.index + m[0].length;
      }
      if (last < s.length) f.appendChild(D.createTextNode(s.slice(last)));
      node.parentNode.replaceChild(f, node);
    });
  }
  function init() {
    if (!D.querySelector('.ptw-ws__tiles > .ptw-wst')) return;
    [].forEach.call(D.querySelectorAll('.ptw-ws__tiles .ptw-wst__t'), function (b) { try { wbr(b); } catch (e) {} });
    // the CSS clamp keys on this class, so with no JS every tile shows in full (progressive enhancement)
    [].forEach.call(D.querySelectorAll('.ptw-ws__tiles'), function (r) { r.classList.add('ptw-ws--clamp'); });
    measure();
    if (W.ResizeObserver) { var ro = new ResizeObserver(later); tiles().forEach(function (li) { ro.observe(li); }); }
    W.addEventListener('resize', later);
    if (WIDE.addEventListener) WIDE.addEventListener('change', later); else if (WIDE.addListener) WIDE.addListener(later);
    W.addEventListener('load', later, { once: true });
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(later);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
